export default function Footer() {
  const scrollToTop = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {/* Brand */}
            <div>
              <a href="#hero" onClick={scrollToTop} className="inline-block">
                <span className="text-xl md:text-2xl font-heading font-bold text-background-50">韩漫网</span>
              </a>
              <p className="mt-3 text-sm text-background-400 leading-relaxed">
                免费韩漫阅读平台，海量免费韩漫资源每日更新。下拉式阅读无需等待，韩漫免费漫画全集在线看，满足每一位韩漫爱好者的追更需求。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <nav className="flex flex-col gap-2">
                <a href="#cards" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">精选推荐</a>
                <a href="#ranking" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">热度榜单</a>
                <a href="#updates" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">最新快讯</a>
                <a href="#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">常见问答</a>
                <a href="#contact" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">联系投稿</a>
              </nav>
            </div>

            {/* Topics */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门话题</h4>
              <nav className="flex flex-col gap-2">
                <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">恋爱韩漫</a>
                <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">奇幻韩漫</a>
                <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">悬疑韩漫</a>
                <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">动作韩漫</a>
                <a href="#topics" className="text-sm text-background-400 hover:text-background-100 transition-colors whitespace-nowrap">校园韩漫</a>
              </nav>
            </div>

            {/* Partners */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
              <p className="text-sm text-background-400 leading-relaxed">
                欢迎漫画平台、创作者及内容方洽谈合作。合作方式包括内容授权、联合推广与品牌联名，共同为韩漫爱好者提供更优质的阅读体验。
              </p>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-10 pt-6 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 韩漫网 · 韩漫免费漫画全集下拉式在线看
            </p>
            <div className="flex items-center gap-4">
              <a href="#faq" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">常见问答</a>
              <a href="#contact" className="text-xs text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}